
import React, { Component } from 'react';
import * as EquipmentAction from '../actions/EquipmentAction';
import EquipmentsStore from '../stores/EquipmentStore';
import * as $ from 'jquery';
import * as CookieService from '../CookieService';
import swal from 'sweetalert';
import SDIConstants from '../SDIConstants';
import * as App from '../App';
import WOPartsComponent from '../components/WOPartsComponent';
import ReactPaginate from 'react-paginate';
import { withTranslation, Trans } from 'react-i18next';

let equipmentDelete = false;

class EquipmentComponent extends Component {
    constructor(props) {
        super(props);
        this.bindcategory = this.bindcategory.bind(this);
        this.bindsubcategory = this.bindsubcategory.bind(this);
        this.formbo = this.formbo.bind(this);
        this.PageLoad = this.PageLoad.bind(this);
        this.PageLoadResponse = this.PageLoadResponse.bind(this);
        this.WOClick = this.WOClick.bind(this);
        this.WOclear = this.WOclear.bind(this);
        this.WO_Parts_ButtonClick = this.WO_Parts_ButtonClick.bind(this);
        this.WONumChange = this.WONumChange.bind(this);
        this.onChangeValues = this.onChangeValues.bind(this);
        this.onChangeValuesResponse = this.onChangeValuesResponse.bind(this);
        this.WOClickResponse = this.WOClickResponse.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handlePageClick = this.handlePageClick.bind(this);
        this.valueResponse = this.valueResponse.bind(this);
        this.Equipmentaddclick = this.Equipmentaddclick.bind(this);
        this.EquipmentAddClickresponse = this.EquipmentAddClickresponse.bind(this);
        this.WorkOrderFail = this.WorkOrderFail.bind(this);
        this.quantityChange = this.quantityChange.bind(this);
        equipmentDelete = false;
        this.state = {
            filterShow: true,
            isModalVisible: false,
            WOErrorMsg: "",
            SearchKeyWord: '',
            PageLoadSearchResults: [],
            FilterValuedata: [],
            searchResultData: [],
            selectCategory: '',
            selectSubCategory: '',
            PageNo: 1,
            pageCount: 0,
            itemPerPage: 5,
            filterApplied: 0,
            TotalItemCount: 0,
            editedQuantity: '',
            WorkOrderNo: localStorage.getItem('WorkOrderNo') || '',
            WOmsg: false,
            subCategory: [], searchresult: [],
            Category: [],
            WO_Parts: JSON.parse(localStorage.getItem('WO_Parts')) || [],
            isValidWO: localStorage.getItem("WONum") == null || localStorage.getItem("WONum") == undefined ? false : true,
            WONum: localStorage.getItem('WONum') || '',
            KIT_Components: '',
            isPageloadValidWO: JSON.parse(localStorage.getItem('isPageloadValidWO')) || false,
            // Added the new state properties based on the errors
            workOrder: '',
            equipmentDelete: false, mixedcart: [],
            hasLoaded: false
        };
    }

    componentDidMount() {
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        //WW-1288 redirecting to the tech vault
        localStorage.setItem("isEquipmentClick", "false");
        let WorkOrder = localStorage.getItem('WONum');
        let WO_Parts = JSON.parse(localStorage.getItem('WO_Parts'))
        let storedWONum = localStorage.getItem('WONum');
        let WOTrade = CookieService.getLocalStorageValues('Trade');
        let Login_UserId = CookieService.getLocalStorageValues("Session_UserID");
        let Session_BUSUNIT = CookieService.getLocalStorageValues("Session_BUSUNIT");
        $("#WorkOrderNo").addClass("disabledbutton");
        if (WorkOrder != null && WorkOrder != undefined && WorkOrder != "") {
            if (!this.state.hasLoaded) {
                this.PageLoad();
                EquipmentsStore.on('EqipmentSearchResult', this.valueResponse);
                EquipmentsStore.on('EqipmentPageLoad', this.PageLoadResponse);
                EquipmentsStore.on('AddToClick', this.EquipmentAddClickresponse);
                EquipmentsStore.on('EquipmentWorkOrder', this.WOClickResponse);
                EquipmentsStore.on('WOfail', this.WorkOrderFail);
                this.setState({ hasLoaded: true, workOrder: storedWONum });
                $("#work-order").addClass("disabledbutton");
            }

        } else {
            this.props.history.push({
                pathname: "/HomePage",
            });
        }
        const fromHome = localStorage.getItem('fromHome');
        if (WO_Parts !== null && WO_Parts !== undefined && WO_Parts !== []) {
            if (storedWONum && WO_Parts.length > 0) {

                //if (fromHome == "true") {
                //    // Show the history pop-up because we came from the home page
                //    $('#WO_Parts_Popup').modal('show');
                //    // Clear the flag so it doesn't show again on other renders
                //    localStorage.setItem('fromHome', false);
                //}
                this.setState({ WONum: storedWONum, WOTrade: WOTrade, Login_UserId: Login_UserId, Session_BUSUNIT: Session_BUSUNIT, workOrder: storedWONum });


            }
        }


    }



    componentWillUnmount() {
        EquipmentsStore.removeListener('EqipmentSearchResult', this.valueResponse);
        EquipmentsStore.removeListener('EqipmentPageLoad', this.PageLoadResponse);
        EquipmentsStore.removeListener('AddToClick', this.EquipmentAddClickresponse);
        EquipmentsStore.removeListener('EquipmentWorkOrder', this.WOClickResponse);
        EquipmentsStore.removeListener('WOfail', this.WorkOrderFail);

    }
    PageLoad = () => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let Session_USERID = CookieService.getLocalStorageValues("Session_UserID");
        let WorkOrder = localStorage.getItem('WONum');
        this.setState({ WONum: WorkOrder });
        let Session_BUSUNIT = (CookieService.getLocalStorageValues("Session_AGENTUSERBU") == "" ? CookieService.getLocalStorageValues("Session_BUSUNIT") : CookieService.getLocalStorageValues("Session_AGENTUSERBU"));
        this.setState({ Session_BUSUNIT: Session_BUSUNIT });
        localStorage.setItem("Session_BUSUNIT", Session_BUSUNIT);
        let WO_Trade = CookieService.getLocalStorageValues('Trade');
        let AGENTUSERID = CookieService.getLocalStorageValues('AGENTUSERID') == "" || undefined || null ? "" : CookieService.getLocalStorageValues('AGENTUSERID');
        let AGENTUSERBU = CookieService.getLocalStorageValues('AGENTUSERBU') == "" || undefined || null ? "" : CookieService.getLocalStorageValues('AGENTUSERBU');
        let Session_SDIEMP = CookieService.getLocalStorageValues('Session_SDIEMP');
        let Session_UserName = CookieService.getLocalStorageValues('Session_UserName') == "" || undefined || null ? "" : CookieService.getLocalStorageValues('Session_UserName');
        let FromWeb = true;
        let pageloadbo = {
            WorkOrder,
            WO_Trade,
            Session_USERID,
            Session_BUSUNIT,
            AGENTUSERID,
            AGENTUSERBU,
            Session_SDIEMP,
            Session_UserName,
            FromWeb,
            Location: CookieService.getLocalStorageValues("Session_WO_STATE") != undefined && CookieService.getLocalStorageValues("Session_WO_STATE") != null && CookieService.getLocalStorageValues("Session_WO_STATE") != "" ? CookieService.getLocalStorageValues("Session_WO_STATE") : CookieService.getLocalStorageValues("Session_STATE") != undefined && CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "",
        };
        EquipmentAction.PageLoad(pageloadbo);
    }
    PageLoadResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let parsedData = JSON.parse(EquipmentsStore.PageLoad);
        let WorkOrder = localStorage.getItem('WONum');



        if (parsedData != null && parsedData != "" && parsedData != undefined) {
            let uniqueCategories = [...new Set(parsedData.map(item => item.Category))];
            this.setState({
                dropdown: parsedData,
                category: uniqueCategories, workOrder: WorkOrder
            });

        } else {
            this.setState({
                dropdown: null,
                category: null, workOrder: WorkOrder,
            });
        }




    };

    bindcategory = () => {
        let category = this.state.category
        if (category && category.length > 0 && category != null && category != undefined) {
            return <>
                <option value="">Select</option>
                {
                    this.state.category.map((cat, index) => (
                        <option value={cat}>{cat}</option>
                    ))}
            </>
        } else {
            return <option value="">No options</option>
        }
    };

    bindsubcategory = () => {
        let subCategory = this.state.subCategory;
        if (subCategory && subCategory.length > 0 && subCategory != null && subCategory != undefined) {
            return (
                <>
                    <option value="">Select</option>
                    {subCategory.map((subcat, index) => (
                        <option key={index} value={subcat}>{subcat}</option>
                    ))}
                </>
            );
        } else {
            return <option value="">No options</option>;
        }
    };

    onChangeValues = (name, event) => {
        //let id = event.target.name;
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let value = this.state.SearchKeyWord || "";
        let subvalue = this.state.selectSubCategory || "";
        let catvalue = this.state.selectCategory || "";



        switch (name) {
            case 'category':
                if (event.target.value !== "" && event.target.value !== null && event.target.value !== undefined) {
                    let subcat = this.state.dropdown.filter(item => item.Category === event.target.value);
                    let subCategoryValues = subcat.map(item => item.SubCategory);
                    this.setState({
                        subCategory: subCategoryValues,
                        selectCategory: event.target.value, filterShow: false, searchResultData: [], selectSubCategory: "",
                    });

                    this.formbo(event.target.value, subvalue, value);
                } else {
                    this.setState({
                        subCategory: [],
                        selectCategory: "", filterShow: true, searchResultData: [], selectSubCategory: ""
                    });
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                }
                break;

            case 'sub-category':
                if (event.target.value !== "" && event.target.value !== null && event.target.value !== undefined) {
                    this.setState({
                        selectSubCategory: event.target.value, filterShow: false, searchResultData: []  // Update selected subcategory
                    });
                    this.formbo(catvalue, event.target.value, value);

                } else {
                    this.setState({
                        selectSubCategory: "", filterShow: false, searchResultData: []
                    });
                    this.formbo(catvalue, "", value);
                }
                break;

            case 'search':
                if (value.trim() !== "" && value.trim() !== " " && value !== null && value !== undefined && value.trim().length > 0) {
                    this.setState({
                        filterShow: false, searchResultData: []  // Update the search keyword
                    });
                    this.formbo(catvalue, subvalue, value);  // Call the form submission function after update

                } else {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                }
                break;
            case 'clearsearch':

                if (catvalue || subvalue) {
                    this.formbo(catvalue, subvalue, "");
                } else {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    this.setState({ filterShow: true, searchResultData: [], SearchKeyWord: "", search: "" });
                }

                break;


            default:
                return;
        }

    };
    formbo = (cat, subcat, search) => {
        // Construct resultBO object based on current state

        const resultBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID") == "" || undefined || null ? "" : CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: (CookieService.getLocalStorageValues("Session_AGENTUSERBU") == "" ? CookieService.getLocalStorageValues("Session_BUSUNIT") : CookieService.getLocalStorageValues("Session_AGENTUSERBU")),
            AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
            Session_UserName: CookieService.getLocalStorageValues("Session_USERNAME"),
            CurrentPage_URL: "/SDIXZEUS/Equipments",
            Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
            Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
            Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
            Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
            Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
            Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
            Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
            Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
            Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
            Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
            Session_SearchQuery: "",
            Session_AMAZONSEARCH: CookieService.getLocalStorageValues("Session_AMAZONSEARCH"),
            SearchValue: "",
            Query_SITE: "",
            Query_USERID: this.state.Login_UserId,
            Query_Key: "",
            Query_Opt: "",
            chbCat: true,
            chbNonCat: true,
            Catagorylist: [],
            Make: "",
            Model: "",
            AssetId: "",
            Quantity: "",
            SupplierIdList: "",
            ManufacturerList: "",
            WorkOrder: localStorage.getItem("WONum") != null ? JSON.parse(localStorage.getItem("WONum")) : "",
            ShipToID: CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") !== "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ",
            Location: CookieService.getLocalStorageValues("Session_WO_STATE") != undefined && CookieService.getLocalStorageValues("Session_WO_STATE") !== "" ? CookieService.getLocalStorageValues("Session_WO_STATE") : CookieService.getLocalStorageValues("Session_STATE") !== undefined && CookieService.getLocalStorageValues("Session_STATE") !== "" ? CookieService.getLocalStorageValues("Session_STATE") : "",
            FavYourCatg: "",
            Session_ID: CookieService.getLocalStorageValues("Session_ID"),
            SOURCE: "WEB",
            IsSupplierSearch: true,
            IsPickupSupplier: localStorage.getItem("pickupcheck") !== null ? JSON.parse(localStorage.getItem("pickupcheck")) : false,
            IsImageSearch: false,
            Files: "",
            ImgByteCode: "",
            ImageName: "",
            isEquipment: true,
            EquipmentCategory: cat,
            EquipmentSubCategory: subcat,
            EquipmentSearchKeyWord: search,
            EquipmentTrade: CookieService.getLocalStorageValues('Trade'),
            Location: CookieService.getLocalStorageValues("Session_WO_STATE") != undefined && CookieService.getLocalStorageValues("Session_WO_STATE") != null && CookieService.getLocalStorageValues("Session_WO_STATE") != "" ? CookieService.getLocalStorageValues("Session_WO_STATE") : CookieService.getLocalStorageValues("Session_STATE") != undefined && CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "",
        };
        // Show loader at the start
        EquipmentAction.onChangeValues(resultBO);
    };
    Searchclear = () => {
        this.setState({ SearchKeyWord: "", searchResultData: [] });
        this.onChangeValues('clearsearch', "");

    }
    onChangesearch = (e) => {
        const inputValue = e.target.value.trim(); // Remove leading and trailing spaces
        if (inputValue !== "") {
            // If the trimmed value is not empty, update the search keyword
            this.setState({ SearchKeyWord: e.target.value });
        } else {
            if (this.state.SearchKeyWord.length > 0) {
                this.onChangeValues('clearsearch', "");
                this.setState({ SearchKeyWord: "" });
            }

        }
    }
    valueResponse = () => {
        let searchResultData = JSON.parse(EquipmentsStore.OnChange);
        debugger
        let response_data = searchResultData.SearchItemTable;
        if (response_data != null && response_data !== undefined && response_data.length != 0) {
            let totalItems = response_data.length;
            let pageCount = Math.ceil(totalItems / this.state.itemPerPage);
            this.setState({
                searchResultData: response_data,
                searchresult: response_data,
                pageCount: pageCount,
                PageNo: 1,  // Reset to first page
            });
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        } else {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            this.setState({
                searchResultData: [],
                searchresult: [],
                pageCount: 0,
                PageNo: 0,  // Reset to first page
            });
        }




    }

    quantityChange = (index, type, e = null) => {

        // Create a shallow copy of the array
        let updatedData = [...this.state.searchResultData];
        let item = { ...updatedData[index] };
        let currentQty = e ? parseInt(e.target.value) : item.quantity != null && item.quantity !== "" && item.quantity !== undefined ? item.quantity : parseInt(item.min_order_qty);
        if (type === "+" && currentQty < 9999) {
            currentQty = parseInt(currentQty) + 1;
        } else if (type === "-" && currentQty > item.min_order_qty) {
            currentQty = currentQty - 1;
        } else if (currentQty === "" || isNaN(currentQty)) {
            currentQty = null;
        }
        if (e) {
            let inputValue = e.target.value;
            if (inputValue.length > 5) {
                // Slice to keep only the last 5 characters
                inputValue = inputValue.slice(0, 5);
            }
            if (inputValue == "" || isNaN(inputValue)) {
                currentQty = null;
            } else {
                currentQty = parseInt(inputValue);
            }
            if (currentQty < item.min_order_qty) {
                currentQty = item.min_order_qty;
            }
        }
        item.quantity = currentQty;
        updatedData[index] = item;
        this.setState({ searchResultData: updatedData })
    };



    onChangeValuesResponse = () => {
        let response_data = this.state.searchResultData;
        const { PageNo } = this.state;

        // Check if the response data is valid
        if (response_data && response_data.length > 0) {
            // Add the 'hide' class to the loader once before rendering

            // Calculate pagination bounds
            const startIndex = (PageNo - 1) * 10;
            const endIndex = startIndex + 10;

            // Paginate the data by slicing it based on the current page number
            const paginatedData = response_data.slice(startIndex, endIndex);

            // If there's data for the current page, render it
            if (paginatedData.length > 0) {
                return paginatedData.map((val, index) => {
                    return (<div className="product-list-parent">
                        <div className="product-list">
                            <div className="row m-0">
                                <div className="col-md-3 custom-product-image">
                                    <img
                                        src={val.ThumbnailImagefile}
                                        onError={(e) => { e.target.src = "/Images/noimage_new.png"; }}
                                        alt="product"
                                    />
                                </div>
                                <div className="col-md-6 custom-product-specification">
                                    <h3 className="custom-product-title">{val.mfg_part_number}</h3>
                                    <p className="custom-product-description">{val.long_desc}</p>
                                    <div className="row custom-product-details">
                                        <div className="col-md-4">
                                            <h4> <Trans>Manufacturer</Trans>:</h4>
                                            <span>{val.manufacturer}</span>
                                        </div>
                                        <div className="col-md-4">
                                            <h4><Trans>Supplier</Trans>:</h4>
                                            <span>{val.supplier}</span>
                                        </div>
                                        <div className="col-md-4">
                                            <h4><Trans>Supplier Part#</Trans>:</h4>
                                            <span>{val.supplier_part_number}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3 custom-product-add-cart">
                                    <div class="quantity buttons_added alignment-end">
                                        <input type="button"
                                            value="-"
                                            className="minus"
                                            disabled={val.quantity ? (val.quantity == val.min_order_qty) : true}
                                            onClick={() => this.quantityChange(index, "-")}
                                            style={{ "backgroundColor": "white" }} />
                                        <input type="number"
                                            className="minus"
                                            maxLength="5"
                                            value={val.quantity || val.min_order_qty}
                                            name="Quantity " title="Qty"
                                            size="4" style={{ "width": "30%", "borderLeft": "0" }}
                                            onChange={(e) => this.quantityChange(index, null, e)} />
                                        <input type="button" value="+" class="plus" disabled={val.quantity && val.quantity.toString().length >= 5} onClick={() => this.quantityChange(index, "+")}
                                            style={{ "backgroundColor": "white" }} />
                                    </div>


                                    <button
                                        className="btn custom-btn-primary px-3"
                                        onClick={() => this.Equipmentaddclick(val)}
                                    >
                                        <img src="Images/cart-icon-black.svg" alt="cart-icon-black" className="cart-icon-black" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>)
                });
            } else {
                // If no data for the current page, show the "No records found" message
                return (
                    <div className="no-record-found-section">
                        <img src="/Images/no-record-found-img.svg" alt="No records found" />
                        <p><Trans>No records found</Trans></p>
                    </div>
                );
            }
        } else {
            // If there's no valid data or the response is empty

            return (
                <div className="no-record-found-section">
                    <img src="/Images/no-record-found-img.svg" alt="No records found" />
                    <p><Trans>No records found</Trans></p>
                </div>
            );
        }

    };



    handleClose = () => {
        $('#EquipmentWorkOrderPopUp').modal('hide');
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        //this.setState({ isModalVisible: false, SearchKeyword: "", WONum: "", hasLoaded: true, category: [], searchResultData: [], subCategory:[],});
        this.props.history.push({
            pathname: '/HomePage',
        });
    };

    WO_Parts_ButtonClick = (e, WOhistory) => {

        if (WOhistory == true) {
            $('#WO_Parts_Popup').modal('show');
        }
        else {
            $('#WO_Parts_Popup').modal('hide');
        }
    }

    WOClick = () => {
        if (this.state.WONum.trim() != "") {
            if (CookieService.getLocalStorageValues("Session_CC_VALIDATE_WO") != 'N') {
                let OLWorkOrder = this.state.WONum;
                let THIRDPARTY_COMP_ID = ""
                if (CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null) {
                    THIRDPARTY_COMP_ID = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID")
                }
                let BO = {
                    workOrder: OLWorkOrder,
                    Session_THIRDPARTY_COMP_ID: THIRDPARTY_COMP_ID,
                    User_Type: CookieService.getLocalStorageValues("Session_SDIEMP"),
                    is_WO_Parts_Needed: true
                }
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                $('#EquipmentWorkOrderPopUp').modal('hide');
                EquipmentAction.WOcheck(BO);
            }
            else {
                $('#EquipmentWorkOrderPopUp').modal('hide');
                let storedWONum = localStorage.getItem('WONum');
                this.setState({
                    WOmsg: false, WorkOrderNo: this.state.WONum, workOrder: this.state.WONum
                })
            }
        }
        else {
            this.setState({ WOErrorMsg: "Please enter work order number" })
        }

    }


    WOclear = () => {

        this.setState({
            WOErrorMsg: "",
            WONum: "",
            selectSubCategory: "",
            selectCategory: "",
            workOrder: "",
            isValidWO: false,
            category: null,
            subcategory: null,
            SearchKeyword: null,
            searchResultData: [],
            isModalVisible: true,
        });
        localStorage.removeItem('WONum');
        localStorage.removeItem('WOAssetID');
        localStorage.removeItem('StoreValue');
        localStorage.removeItem('WOAssetTag');
        localStorage.removeItem('WO_Parts');
        const itemsToUpdate = [
            'AssetTag', 'AssetID', 'Trade', 'Category', 'Make', 'Model',
            'WO_Make', 'WO_Model', 'WO_Address'
        ];

        itemsToUpdate.forEach(item => {
            localStorage.setItem(item, '');
        });
        $('#EquipmentWorkOrderPopUp').modal('show');
    }

    WONumChange = (e) => {
        const onlyNumbers = SDIConstants.quantityRegEX;
        if (e.target.value === '' || onlyNumbers.test(e.target.value)) {
            this.setState({ WONum: e.target.value, WOErrorMsg: "" });
        }
    }

    WOClickResponse = () => {
        debugger
        let Workorderresponse = JSON.parse(EquipmentsStore.WorkOrder);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let localstore = "";
        let localWON = this.state.WONum;
        let loacalloc = "";
        let BilltoStoreLocationLat = 0;
        let BilltoStoreLocationLong = 0;
        let BilltoStore = "";
        let WO = JSON.stringify(localWON)
        let workorder = localStorage.setItem("WONum", (JSON.stringify(localWON)).substring(1, WO.length - 1));
        if (Workorderresponse.WOResponse) {
            if (Workorderresponse.WOResponse.length > 0) {

                if (Workorderresponse.WOResponse[0].AssetID != "" && Workorderresponse.WOResponse[0].AssetID != null && Workorderresponse.WOResponse[0].AssetID != undefined && Workorderresponse.WOResponse[0].AssetID != " ") {
                    localStorage.setItem('WOAssetID', Workorderresponse.WOResponse[0].AssetID);
                    localStorage.setItem('WOAssetTag', Workorderresponse.WOResponse[0].AssetTag);
                    if (Workorderresponse.WOResponse[0].WO_Make != "" && Workorderresponse.WOResponse[0].WO_Make != null && Workorderresponse.WOResponse[0].WO_Make != undefined && Workorderresponse.WOResponse[0].WO_Make != " ") {
                        CookieService.updateLocalStorageValues("WO_Make", Workorderresponse.WOResponse[0].WO_Make);
                    } if (Workorderresponse.WOResponse[0].WO_Model != "" && Workorderresponse.WOResponse[0].WO_Model != null && Workorderresponse.WOResponse[0].WO_Model != undefined && Workorderresponse.WOResponse[0].WO_Model != " ") {
                        CookieService.updateLocalStorageValues("WO_Model", Workorderresponse.WOResponse[0].WO_Model);
                    }
                }
                let workorder = Workorderresponse.WOResponse;
                $("#work-order").addClass("disabledbutton");
                let homestoreloc = CookieService.getLocalStorageValues("LOCATION");
                CookieService.updateLocalStorageValues("homestoreloc", homestoreloc);
                CookieService.updateLocalStorageValues("LOCATION", Workorderresponse.WOResponse[0].COUNTRY);
                localStorage.setItem("Country", Workorderresponse.WOResponse[0].COUNTRY);
                CookieService.updateLocalStorageValues("AssetTag", Workorderresponse.WOResponse[0].AssetTag);
                CookieService.updateLocalStorageValues("WO_Address", Workorderresponse.WOResponse[0].ADDRESS1)
                CookieService.updateLocalStorageValues("AssetID", Workorderresponse.WOResponse[0].AssetID);
                CookieService.updateLocalStorageValues("Trade", Workorderresponse.WOResponse[0].Trade);
                CookieService.updateLocalStorageValues("WO_Type", Workorderresponse.WOResponse[0].WO_Type);
                CookieService.updateLocalStorageValues("WO_Category", Workorderresponse.WOResponse[0].Category);
                CookieService.updateLocalStorageValues("WO_Priority", Workorderresponse.WOResponse[0].Priority);
                CookieService.updateLocalStorageValues("NTEAmount", Workorderresponse.WOResponse[0].NTE);
                CookieService.updateLocalStorageValues("WO_CAT_DESC", Workorderresponse.WOResponse[0].WO_CAT_DESC);
                CookieService.updateLocalStorageValues("Session_WO_STATE", Workorderresponse.WOResponse[0].STATE);
                CookieService.updateLocalStorageValues("IsBlanketWO", Workorderresponse.WOResponse[0].IsBlanketWO); // Setting stating the ship to the IsBlanketWO if the user selects the W09301 location
                let WO = JSON.stringify(localWON)
                localStorage.setItem("WONum", (JSON.stringify(localWON)).substring(1, WO.length - 1));
                localStorage.setItem("StoreValue", JSON.stringify(loacalloc));

                //WW-1374 Update the WO logo, Problem code long and short description to cookie - Nandhini L 
                CookieService.updateLocalStorageValues("Logo", Workorderresponse.WOResponse[0].Logo);
                CookieService.updateLocalStorageValues("ProblemCodeDescription", Workorderresponse.WOResponse[0].ProblemCodeDescription);
                CookieService.updateLocalStorageValues("Description", Workorderresponse.WOResponse[0].Description);

                let locWO_parts = []
                locWO_parts = Workorderresponse.WOParts;

                if (Workorderresponse.WOParts != undefined && Workorderresponse.WOParts != null) {

                    if (Workorderresponse.WOParts.length > 0) {
                        CookieService.updateLocalStorageValues("WO_Parts", Workorderresponse.WOParts);
                        localStorage.setItem("WO_Parts", JSON.stringify(Workorderresponse.WOParts));
                        locWO_parts = Workorderresponse.WOParts;
                        let storedWONum = localStorage.getItem('WONum');
                        let WOTrade = CookieService.getLocalStorageValues('Trade');
                        let Login_UserId = CookieService.getLocalStorageValues("Session_UserID");
                        let Session_BUSUNIT = CookieService.getLocalStorageValues("Session_BUSUNIT");
                        $('#WO_Parts_Popup').modal('show');
                        this.setState({ WONum: storedWONum, WO_Parts: locWO_parts, WOTrade: WOTrade, Login_UserId: Login_UserId, Session_BUSUNIT: Session_BUSUNIT, workOrder: storedWONum });


                    }
                }

                if (Workorderresponse.WOResponse[0].LOCATION != "" && Workorderresponse.WOResponse[0].LOCATION != null && Workorderresponse.WOResponse[0].LOCATION != undefined && Workorderresponse.WOResponse[0].LOCATION != " ") {
                    localstore = Workorderresponse.WOResponse[0].ADDRESS1
                    loacalloc = Workorderresponse.WOResponse[0].LOCATION;
                    let storeval = Workorderresponse.WOResponse[0].DESCR;
                    let BenPickLbl = localstore + " " + "-" + " " + loacalloc
                    BilltoStoreLocationLat = Workorderresponse.WOResponse[0].LATITUDE;
                    BilltoStoreLocationLong = Workorderresponse.WOResponse[0].LONGITUDE;
                    BilltoStore = Workorderresponse.WOResponse[0].DESCR_AC;
                    if (loacalloc != null && loacalloc != undefined) {
                        localStorage.setItem("ShipToID", JSON.stringify(loacalloc));
                        let WO = JSON.stringify(localWON)
                        localStorage.setItem("WONum", (JSON.stringify(localWON)).substring(1, WO.length - 1));
                        localStorage.setItem("StoreValue", JSON.stringify(loacalloc));
                        localStorage.setItem("BilltoStoreLocationLat", BilltoStoreLocationLat);
                        localStorage.setItem("BilltoStoreLocationLong", BilltoStoreLocationLong);
                        localStorage.setItem("BiltoStoreValue", BilltoStore);
                        localStorage.setItem("Country", Workorderresponse.WOResponse[0].COUNTRY);
                        localStorage.setItem("BenPickLbl", JSON.stringify(BenPickLbl));
                    }
                    $('#WorkOrder').modal('hide');
                    let storedWONum = localStorage.getItem('WONum');
                    this.setState({
                        WOmsg: false, WorkOrderNo: localWON, StoreValue: loacalloc, workOrder: storedWONum
                    })
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');

                }



                else {
                    this.setState({ WOmsg: true })
                }
                if (Workorderresponse.WOResponse[0].Trade && Workorderresponse.WOResponse[0].Trade.trim() !== "") {
                    this.PageLoad();
                }
                let storedWONum = localStorage.getItem('WONum');
                this.setState({ WO_Parts: locWO_parts, isValidWO: true, isPageloadValidWO: false, workOrder: storedWONum })

            } else {

                alert("Enter Valid Work Order #")
            }



        }
        else {

            alert("Enter Valid Work Order #")
        }




    }
    handleEquipmentYes = () => {
        $('#EquipmentMixed').modal('hide');

        equipmentDelete = true;
        this.Equipmentaddclick(this.state.mixedcart);


    };
    Equipmentaddclick = (value) => {
        let existingCartItems = localStorage.getItem('CartStorage');

        if (existingCartItems.length > 0) {
            existingCartItems = JSON.parse(existingCartItems);
            let hasIsaWbsElmnt = existingCartItems.filter(item => item.ISA_WBS_ELMNT !== 'Equipment');

            if (!equipmentDelete && hasIsaWbsElmnt.length > 0) {
                $('#EquipmentMixed').modal('show');
                this.setState({ mixedcart: value });
                return
            }

        }

        let Kit_Component = JSON.parse(value.kit_Items)
        let KitItems = []
        const queryParams = new URLSearchParams(window.location.search)


        let QS_srcs = queryParams.get('key');
        Kit_Component.forEach((val) => {
            KitItems.push(val.SupplierPartNumber);

        });

        let KitBO = {

            Session_USERID: CookieService.getLocalStorageValues("Session_UserID") == "" || undefined || null ? "" : CookieService.getLocalStorageValues("Session_UserID"),
            AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
            Session_UserName: CookieService.getLocalStorageValues("Session_USERNAME"),
            CurrentPage_URL: "/SDIXZEUS/searchResults",
            Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
            Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
            Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
            Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
            Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
            Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
            Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
            Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
            Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
            Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
            Session_SearchQuery: " ",
            Session_AMAZONSEARCH: CookieService.getLocalStorageValues("Session_AMAZONSEARCH"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
            Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
            Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
            SearchValue: "",
            Query_SITE: "",
            Query_USERID: CookieService.getLocalStorageValues("Session_UserID") == "" || undefined || null ? "" : CookieService.getLocalStorageValues("Session_UserID"),
            Query_Key: QS_srcs,
            Query_Opt: "",
            chbCat: true,
            chbNonCat: true,
            Catagorylist: [],
            Make: "",
            Model: "",
            AssetId: "",
            SupplierIdList: [],
            ManufacturerList: [],
            WorkOrder: localStorage.getItem("WONum") != null ? JSON.parse(localStorage.getItem("WONum")) : "",
            ShipToID: CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") != undefined && CookieService.getLocalStorageValues("HOME_STORE") != "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ",
            Location: CookieService.getLocalStorageValues("Session_WO_STATE") != undefined && CookieService.getLocalStorageValues("Session_WO_STATE") != null && CookieService.getLocalStorageValues("Session_WO_STATE") != "" ? CookieService.getLocalStorageValues("Session_WO_STATE") : CookieService.getLocalStorageValues("Session_STATE") != undefined && CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "", //WW-1231 WO State Restriction -Vishwa S
            FavYourCatg: "",
            Session_ID: CookieService.getLocalStorageValues("Session_ID"),
            SOURCE: "WEB",
            IsSupplierSearch: true,
            KitQty: value.quantity || value.min_order_qty,
            MachineNo: "",
            KitOrderLocation2: CookieService.getLocalStorageValues("Session_WO_STATE") != undefined && CookieService.getLocalStorageValues("Session_WO_STATE") != null && CookieService.getLocalStorageValues("Session_WO_STATE") != "" ? CookieService.getLocalStorageValues("Session_WO_STATE") : CookieService.getLocalStorageValues("Session_STATE") != undefined && CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "", //WW-1231 WO State Restriction -Vishwa S
            KitOrderType: "",
            KitItem: value.kit_Items,
            IsKitSearch: true,
            EquipmentDelete: equipmentDelete,
            IsAddtoCartWeb: true,
            ItemIdList: KitItems,
            isEquipment: true,
            Session_UserID: CookieService.getLocalStorageValues("Session_UserID") == "" || undefined || null ? "" : CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: (CookieService.getLocalStorageValues("Session_AGENTUSERBU") == "" ? CookieService.getLocalStorageValues("Session_BUSUNIT") : CookieService.getLocalStorageValues("Session_AGENTUSERBU")),
            Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
            Interactive: false,
            EquipmentTrade: CookieService.getLocalStorageValues('Trade'),

        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        EquipmentAction.EquipmentaddCLick(KitBO);


    }
    KeyPress = (e, type) => {
        if (type === "work") {
            if (e.keyCode == 13) {
                this.WOClick();
            }
        } else if (type === "search") {
            if (e.keyCode == 13) {
                this.onChangeValues('search', e);
            }
        }

    }

    EquipmentAddClickresponse = () => {
        let Status = JSON.parse(EquipmentsStore.AddToCart);
        console.log("Status_Add", Status);
        equipmentDelete = false;
        let itemstatus = Status._FlagDt;
        let iteminsertstatus = Status.SuccessFLag;
        let PageLSearchResults = this.state.PageLoadSearchResults;
        let FilterdValue = this.state.FilteredSearchResults;

        if (itemstatus.length > 0) {
            if (itemstatus[0].is_Success === "True" || itemstatus[0].is_Success === "true") {
                // Store the search keyword in local storage
                CookieService.updateLocalStorageValues("Session_SearchValue", this.state.SearchKeyWord);
                let itemidnotinserted = "";

                // Check which items were not inserted due to technical issues
                if (iteminsertstatus != null && iteminsertstatus !== undefined && iteminsertstatus !== "") {
                    iteminsertstatus.forEach(val => {
                        if (val.Status !== "true") {
                            itemidnotinserted = itemidnotinserted ? `${itemidnotinserted},${val.ItemId}` : val.ItemId;
                        }
                    });
                }

                // Show a warning popup if items weren't added due to technical issues
                if (itemidnotinserted) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: `Item ${itemidnotinserted} is not added to cart due to technical issue. Contact SDI customer care.`,
                    });
                }

                // Show success message if items were successfully added
                $(`#${SDIConstants.SDILoader}`).addClass('hide');

                this.props.toastSuccessMessage("Item successfully added to cart");


                // Hide the loader

            } else {
                // Store the search keyword in local storage
                CookieService.updateLocalStorageValues("Session_SearchValue", this.state.SearchKeyWord);
                let itemidnotinserted = "";
                let validate = false;

                // Check which items were not inserted and validate success status
                if (iteminsertstatus != null && iteminsertstatus !== undefined && iteminsertstatus !== "") {
                    iteminsertstatus.forEach(val => {
                        if (val.Status !== "true") {
                            itemidnotinserted = itemidnotinserted ? `${itemidnotinserted},${val.ItemId}` : val.ItemId;
                        } else if (!validate) {
                            validate = true;
                        }
                    });
                }

                // Show a warning popup if items weren't added due to technical issues
                if (itemidnotinserted) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Technical Issue. Please contact SDI Customer Care"
                    });
                }

                // Show success popup if validation is true
                if (validate) {
                    this.props.toastSuccessMessage("Item successfully added to cart")

                    // Update the quantity of the items in the search results
                    PageLSearchResults[this.state.pageresqty].QuantityOrdered = PageLSearchResults[this.state.pageresqty].min_order_qty;
                    FilterdValue[this.state.pageresqty].QuantityOrdered = PageLSearchResults[this.state.pageresqty].min_order_qty;
                    PageLSearchResults[this.state.cheaperIndex].QuantityOrdered = PageLSearchResults[this.state.cheaperIndex].min_order_qty;
                    FilterdValue[this.state.cheaperIndex].QuantityOrdered = PageLSearchResults[this.state.cheaperIndex].min_order_qty;
                    console.log(PageLSearchResults, FilterdValue);

                    // Update the component state with the new search results
                    this.setState({ PageLoadSearchResults: PageLSearchResults, FilteredSearchResults: FilterdValue });
                } else if (!itemidnotinserted) {
                    // Show an error message if there's a technical issue
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Technical Issue. Please contact SDI Customer Care"
                    });
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                } else {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                }
            }
        }
    }



    handlePageClick = (e) => {
        let pageNo = e.selected + 1;
        this.setState({ PageNo: pageNo });
    };

    WOHistoryClose = () => {
        $('#WO_Parts_Popup').modal('hide');
    }

    WorkOrderFail = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        this.setState({ WOErrorMsg: "Enter valid work order number" });
        $('#EquipmentWorkOrderPopUp').modal('show');
    }
    render() {
        const { t } = this.props;
        const { workOrder, category, subCategory, searchKeyword, categories, subCategories, isModalVisible } = this.state;

        return (
            <React.Fragment>
                <div className="container-fluid equipments-page" >
                    <div className="row p-1" >
                        <div className="col-md-12 equipmentheader" >
                            <h5 className="page-title-equipment border-bottom pb-4 margin-top page-title" ><Trans>Equipment</Trans> </h5>
                        </div>
                        <div className="parent-section">
                            <div className="filter-btn-section pb-4 border-bottom">
                                <div className="custom-m-100">
                                    <label className="form-label" htmlFor="work-order"><Trans>workorder_key</Trans> #</label>
                                    <div class="input-group charge-code-group">
                                        <input
                                            type="text"
                                            className="form-control search-field"
                                            placeholder="Enter WO#"
                                            id="work-order"
                                            maxLength="9"
                                            pattern="[0-9]*"
                                            ref={this.WOText}
                                            value={this.state.workOrder}
                                            defaultValue={''}
                                        />
                                        {this.state.workOrder !== undefined && this.state.workOrder !== null && this.state.workOrder !== "" && this.state.workOrder !== " " && (
                                            <span className="search-cancel-header cursor-pointer" style={{ right: "40px" }} onClick={() => this.WOclear()}></span>
                                        )}
                                        <div className="input-group-append" data-toggle="modal" onClick={(e) => this.WOClick()}>
                                            <span className="input-group-text input-search-icon">
                                                <span className="shopping-search-icon"></span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                {this.state.isValidWO != false && this.state.WO_Parts.length != 0 ? 
                                <div className="custom-m-100 custom-tab-button">
                                    <button className="btn custom-btn-primary px-3 w-space-no-wrap" onClick={e => this.WO_Parts_ButtonClick(e,true)}>
                                        <img src="Images/History-clock-icon.svg" alt="History-clock-icon" className="history-clock-icon" />
                                            <Trans>WO#_History</Trans> 
                                </button>
                                    </div> : null}



                                <div className="custom-m-100">
                                    <label className="form-label" htmlFor="category"><Trans>Category</Trans></label>
                                    <select
                                        className="form-control select-field"
                                        name="category"
                                        value={this.state.selectCategory}
                                        onChange={(e) => this.onChangeValues('category', e)}>

                                        {this.bindcategory()}
                                    </select>
                                </div>
                                <div className="custom-m-100">
                                    <label className="form-label" htmlFor="sub-category"><Trans>Sub_category</Trans></label>
                                    <select
                                        className="form-control select-field"
                                        name="sub-category"
                                        disabled={!this.state.selectCategory}
                                        value={this.state.selectSubCategory}
                                        onChange={(e) => this.onChangeValues('sub-category', e)}>
                                        {this.bindsubcategory()}
                                    </select>
                                </div>

                                <div className="custom-m-100">
                                    <label className="form-label" htmlFor="search"><Trans>Search</Trans></label>
                                    <div className="input-group charge-code-group">
                                        <input
                                            type="text"
                                            id="search"
                                            className="form-control search-field search-width-full"
                                            placeholder="Enter"
                                            onKeyDown={(e) => this.KeyPress(e, "search")}
                                            value={this.state.SearchKeyWord}
                                            onChange={(e) => this.onChangesearch(e)}
                                        />
                                        {this.state.SearchKeyWord !== undefined && this.state.SearchKeyWord !== null && this.state.SearchKeyWord !== "" && this.state.SearchKeyWord !== " " && this.state.SearchKeyWord.length > 0 && (
                                            <span className={this.state.SearchKeyWord.trim().length > 0 ? "search-cancel-header cursor-pointer" : "d-none"} style={{ right: "40px" }} onClick={() => this.Searchclear()}></span>
                                        )}
                                        <div className="input-group-append">
                                            <span className="input-group-text input-search-icon">
                                                <span className="shopping-search-icon" onClick={(e) => this.onChangeValues('search', e)}></span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {this.state.filterShow ? (
                                <div className="no-record-found-section">
                                    <img src="Images/select-file-to-view-img.svg" alt="select-file-to-view-img" className="no-record-found" />
                                    <h5><Trans>Filter records</Trans> </h5>
                                    <p className="custom-select-records"><Trans>Please select any fields to view the equipments</Trans> </p>
                                </div>
                            ) : (
                                    this.onChangeValuesResponse() // Call the function directly
                                )}

                            {this.state.searchResultData && this.state.searchResultData.length > 0 && (
                                <div className=" d-md-flex justify-content-md-between align-items-center pb-3 mt-4">
                                    <span className="font-16 font-medium no-rec-color total-records mt-2 d-inline-block">
                                        <Trans>Number of Records:</Trans>  <span class="primary-textcolor">{this.state.searchResultData.length}</span>
                                    </span>
                                    {this.state.searchResultData.length > 10 ?
                                        < ReactPaginate
                                            previousLabel={<span className="right-pagination-arrow" />}
                                            nextLabel={<span className="left-pagination-arrow" />}
                                            previousClassName={'page-item'}
                                            nextClassName={'page-item'}
                                            previousLinkClassName={'page-link'}
                                            nextLinkClassName={'page-link'}
                                            disabledClassName={'disabled'}
                                            breakLabel={'...'}
                                            breakClassName={'page-item'}
                                            breakLinkClassName={'page-link'}
                                            pageCount={this.state.pageCount}
                                            marginPagesDisplayed={1}
                                            pageRangeDisplayed={2}
                                            onPageChange={this.handlePageClick}
                                            containerClassName={'custom-pagination pagination float-right'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            activeClassName={'active'}
                                            hrefBuilder={() => '#'}
                                            forcePage={this.state.PageNo - 1}

                                        /> : null}

                                </div>
                            )}
                        </div>

                    </div>
                </div>
                <div className="modal fade Interactive-Noncat-Confirmation-modal p-0" id="EquipmentMixed" data-backdrop="static"
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content border-0">
                            <div className="modal-header sp-delv-header align-items-center px-4">
                                <h5 className="modal-title" id="exampleModalLongTitle">
                                    <Trans>Confirmation</Trans> 
                                    </h5>
                            </div>
                            <div className="modal-body font-15 px-4">
                                <Trans>Adding an item will remove the current items in your shopping cart. Do you want to proceed with this change?</Trans>
                                </div>

                            {/*button*/}
                            <div className="modal-footer border-0 px-4">
                                <button className="btn btn-dark-grey font-14 font-medium mr-3 px-4"
                                    type="button"
                                    data-dismiss="modal" ><Trans>No</Trans></button>

                                <button
                                    className="btn btn-custom-primary font-14 font-medium px-4" onClick={this.handleEquipmentYes}
                                    type="button"><Trans>Yes</Trans></button>


                            </div>
                            {/*button*/}
                        </div>
                    </div>
                </div>
                <div className="modal" id="WO_Parts_Popup" >
                    {this.state.isValidWO && this.state.WO_Parts.length > 0 ?
                        <WOPartsComponent closePopup={(e) => this.WO_Parts_ButtonClick(e, false)}  {...this.props} /> : null}
                </div>
                
                <div
                    className={`modal userid Home-WO`}
                    id="EquipmentWorkOrderPopUp"
                    data-backdrop="static"
                    data-keyboard="false"
                    aria-hidden="false" aria-modal="true"
                >
                    <div className="modal-dialog home-wo-input custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title mt-1"><Trans>Work Order</Trans> #</h4>
                                <button
                                    type="button"
                                    className="btn close-btn"
                                    data-dismiss="modal"
                                    onClick={() => { this.handleClose() }}
                                >X</button>
                            </div>
                            <div className="modal-body">
                                <div className="row justify-content-center">
                                    <div className="col-md-11 my-3">
                                        <div className="row">
                                            <label className="confirm-content d-block ml-3"><Trans>Please enter a WO# to continue</Trans> </label>
                                            <div className="col-lg-12 col-md-12 input-group charge-code-group float-left">
                                                <input
                                                    type="text"
                                                    className="form-control charge-code-control"
                                                    placeholder="Enter WO#"
                                                    id="WorkOrder"
                                                    maxLength="9"
                                                    onKeyDown={(e) => this.KeyPress(e, "work")}
                                                    pattern="[0-9]*"
                                                    value={this.state.WONum}
                                                    onChange={this.WONumChange}
                                                    defaultValue={''}
                                                />
                                                {this.state.WONum !== undefined && this.state.WONum !== null && this.state.WONum !== "" && this.state.WONum !== " " && (
                                                    <span className="search-cancel-header cursor-pointer" style={{ right: "58px" }} onClick={() => this.WOclear()}></span>
                                                )}
                                                <div className="input-group-append">
                                                    <span className="input-group-text" onClick={() => this.WOClick()}>
                                                        <span className="shopping-search-icon" />
                                                    </span>
                                                </div>
                                                {this.state.WOErrorMsg.length > 0 ? <span className="errorspan12 text-left my-2" id="StatusMsgbilltostore"><Trans>{this.state.WOErrorMsg}</Trans></span> : null}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>




        );
    }

}


export default withTranslation()(EquipmentComponent);